import { useCallback } from "react"

import { Flex } from "antd"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"

import { DashboardFiltersBlock } from "../../../Components/Filters/DashboardFiltersBlock/DashboardFiltersBlock"
import DropdownBlockCheckbox from "../../../Components/Filters/DropdownBlockCheckbox"
import { TYPE_DATA } from "../../DisputesPage/pages/AllPage/constants/statusMeta"
import { changeAnalyticsFilters, selectAnalyticsFilters } from "../redux/analytics.slice"

import styles from "../analytics.module.less"

const toTypes = (value) =>
  value === "all" || value == null ? [] : Array.isArray(value) ? value : [value]

// Calendar, Compare and Type, shared by the Analytics page and its "View All" pages. They all
// write to the slice, so a card and the page behind it always cover the same window and the same
// case type. `withCompare` is off where nothing on the page shows a comparison.
const AnalyticsFilters = ({ withCompare = true }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const filters = useSelector(selectAnalyticsFilters)

  // A custom range arrives as a bare [from, to]; stored the way Home and Health store it, which
  // is the shape the Compare control reads to tell a custom window from a relative one.
  const handleChangeFilter = useCallback(
    (patch) =>
      dispatch(
        changeAnalyticsFilters(
          Array.isArray(patch.period)
            ? { ...patch, period: { type: "custom", period: patch.period } }
            : patch
        )
      ),
    [dispatch]
  )

  return (
    // wrap: with the calendar, Compare and the Type chip this row is wider than a phone.
    <Flex justify="flex-start" align="center" gap={12} wrap="wrap" className={styles.filterRow}>
      <DashboardFiltersBlock
        onlyPeriod
        showCompare={withCompare}
        filters={filters}
        handleChangeFilter={handleChangeFilter}
      />
      {/* The same chip the Disputes list uses. The "chart" variant is the 40px / 12px-radius
          form the calendar and Compare controls beside it use. */}
      <DropdownBlockCheckbox
        id="dispute_type"
        label={t("Type")}
        iconType="type"
        type="chart"
        labelTooltip={t(
          "Only Amex and Discover raise inquiries: a pre-dispute question you answer before any chargeback is filed. Visa and Mastercard go straight to a dispute."
        )}
        allBtnText={t("All types")}
        data={TYPE_DATA}
        sortDisabled
        dropdownFilters={filters.dispute_type?.length ? filters.dispute_type : "all"}
        setDropdownFilters={(obj) =>
          dispatch(changeAnalyticsFilters({ dispute_type: toTypes(obj.dispute_type) }))
        }
      />
    </Flex>
  )
}

export default AnalyticsFilters
